module.exports = __webpack_public_path__ + "img/auth2.49b51bf1.png";